$ = jQuery.noConflict();

var Testimonials = {
	
	
	init:function(){
		$(window).scroll(function(){
			Testimonials.scroll();
		});
		Testimonials.scroll();


		var _carousel = $(".testimonials-container .testimonials-list");

		if (!_carousel.hasClass('slick-initialized')) {

			_carousel.slick({
				arrows:true,
				prevArrow:"",
				nextArrow:$(".testimonials-container .arrow-next"),
				dots:true,
				infinite: true,
				dots:false,
				variableWidth:true,
				slidesToShow: 1,
				mobileFirst: true,
				focusOnSelect: true,
				touchThreshold:500,
				centerMode:true,
				draggable:true
			});				
		}

		_carousel.on('beforeChange', function(event, slick, currentSlide, nextSlide){									
			Testimonials.changeCarousel(nextSlide, currentSlide);
		});

	},
	changeCarousel:function(_next, _current){
		//console.log("CHANGE CAROUSEL : current : " + _current + " -> next : " + _next );
		
		
		$(".testimonials-container .testimonials-list .testimonial:not(.slick-cloned)").each(function(i){
			if(i == _next){
				//console.log("FOUND : " + $(this).attr("data-type"));
				$(".testimonials-container").removeClass("residence ehpad").addClass($(this).attr("data-type"));
			}
			
		});
		
		$(".testimonials-container .photos-container .photos-list .photo").each(function(i){
			if(i == _next){
				$(this).addClass("current");
			}else{
				$(this).removeClass("current");
			}
		});
		
		$(".testimonials-container .info-bulle-container .text-bulle-container .text-bulle").each(function(i){
			if(i == _next){
				$(this).addClass("current");
			}else{
				$(this).removeClass("current");
			}
		});
		$(".testimonials-container .illustration.left .img-container img").each(function(i){
			if(i == _next){
				$(this).addClass("current");
			}else{
				$(this).removeClass("current");
			}
		});
	},
	scroll:function(){
		var _r = $(window).scrollTop() / 5;
		$(".testimonials-container .logo-mdrs .cercle").css({transform:"rotate("+_r+"deg)", "-webkit-transform":"rotate("+_r+"deg)"})
		
	}
}

$(document).ready(function(){

	if($(".testimonials-container").length){
		Testimonials.init();
	}
});